import { showCtConfirm } from "@conectate/components/ct-confirm.js";
import { getAuth } from "firebase/auth";

import { strings } from "../@strings/strings.js";
import apiv2 from "../api/v2/API.js";
import { PGSchema } from "../api/v2/schemas/pg.schema.js";
import { createStore } from "./store.js";

let initialState: { user: PGSchema.users } = {
	user: {} as any
};

export namespace Assistant {
	let onWay: ReturnType<typeof apiv2.users.getUserInformation> | undefined = undefined;
	let initialized = false;

	export async function getState() {
		if (initialized || getAuth().currentUser?.isAnonymous) return store.getState();
		if (!onWay) onWay = apiv2.users.getUserInformation("me");

		const rsp = await onWay;
		store.set({ user: rsp.json.user });
		initialized = true;
		return store.getState();
	}

	export async function clear() {
		store.set({ user: {} as any });
		initialized = false;
	}

	export const store = createStore<typeof initialState>({
		initialState,
		id: "AssistantUser"
	});

	let autoupdate = true;

	export function setAutoupdate(value: boolean) {
		autoupdate = value;
	}
	store.setOnPrePatch(async (state, rawpartialState) => {
		if (rawpartialState.user == undefined || !autoupdate) return;
		if (!state.user?.id) return;
		let partialState = rawpartialState.user;
		let hasChanged = Object.keys(partialState).some(key => {
			if (typeof partialState[key as keyof typeof partialState] === "object") {
				return JSON.stringify(partialState[key as keyof typeof partialState]) !== JSON.stringify(state.user[key as keyof typeof state.user]);
			}
			return partialState[key as keyof typeof partialState] !== state.user[key as keyof typeof state.user];
		});
		if (hasChanged) {
			let [rsp, err] = await apiv2.users.updateInfo({ ...partialState, id: state.user.id });
			if (err) {
				showCtConfirm(strings.error, `${err.data?.field}. ${strings.invalid_form}`);
			}
		}
	});
}
